import { render, staticRenderFns } from "./bio-acoustic-demo.vue?vue&type=template&id=574617d6"
import script from "./bio-acoustic-demo.vue?vue&type=script&lang=js"
export * from "./bio-acoustic-demo.vue?vue&type=script&lang=js"
import style0 from "./bio-acoustic-demo.vue?vue&type=style&index=0&id=574617d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports